<template>
	<div>
		<div class="simulador_wrapper">
			<div class="container">
				<div class="row">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<div class="simulador">
							<h1>Simule seu consórcio imobiliário</h1>
							<simulador></simulador>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="links_redes_sociais">
			<div class='center'>
				<p>Acompanhe nas redes sociais:</p>
			</div>
			<div class='center'>
				<a href="https://www.facebook.com/hdinvestconsorcios/" target='blank'><i class='fab fa-facebook'></i></a>
				<a href="https://www.instagram.com/hdinvest" target='blank'><i class='fab fa-instagram'></i></a>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		methods:{
			login(){
				window.location.replace('/login');
			}
		}
	}
</script>
